import { connect } from 'react-redux';
import TreeViewBox from './tree-view-box';
import { nodeChanged } from './../common/broadcast-helper';
import { idObjectChanged, setData } from './../root/state/root-actions';

function mapStateToProps(state) {
  return {
    idPlant: state.rootReducer.idPlant ? state.rootReducer.idPlant : 0,
    treeData: state.rootReducer.treeNodes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectionChanged: (node, idObject, modelCode) => {
      nodeChanged(node, modelCode,  dispatch);
      dispatch(idObjectChanged(idObject));
    },
    nodeChanged: (idPlant) => dispatch(nodeChanged(idPlant, dispatch)),
    setData: data => dispatch(setData(data))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TreeViewBox);



/** WEBPACK FOOTER **
 ** app/components/tree-view/tree-view-container.js
 **/